import React from 'react';
import {ConfigLayoutMenuApi} from "../../../../services/Api/types";
import {Link} from "react-router-dom";
import AppConfig from "../../../../services/AppConfig";
import {usePrefix} from "../../../../services/Prefix";

interface Props {
    footerLinks: ConfigLayoutMenuApi[];
}

const FooterLinks = ({footerLinks}: Props) => {
    const prefix = usePrefix();

    return (
        <div className={"footer-links"}>
            <ul className="list-inline">
                {footerLinks.map((footerLink) => {
                    if (footerLink.link == 'rules') {
                        return (
                            <li key={footerLink.link}>
                                <Link
                                    to={AppConfig.getLinkWithPrefix(`/${footerLink.link}`, prefix)}>
                                    {footerLink.title}
                                </Link>
                            </li>
                        )
                    }
                    return (
                        <li key={footerLink.link}>
                            <a href={footerLink.link}>
                                {footerLink.title}
                            </a>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default FooterLinks;